// 원장 호출 — 전체 화면 (/call, 진료실 태블릿 "홈 화면에 추가"용). 명세 §1·§2·§3
//  - 기본 = 진료실 격자만 크게(환자 정보 칸 없음). ?view=doctor = 원장 응답 보기(원장실 PC·원장 휴대폰)
//  - 상단: 원장실 재실/부재 + 시계(서버 시각 보정). 연결 끊김 회색 띠 + 호출 버튼 비활성
//  - 라이트 고정. 나가기 버튼은 구석에 작게. 사이드메뉴 없음(App.js 가 MainLayout 밖에 둔다)
//  - 게이트(로그인·치과·doctorCall 플래그)는 App.js 라우트가 한다
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDoctorCall } from './useDoctorCall';
import DoctorCallGrid from './DoctorCallGrid';
import DoctorCallDoctorView from './DoctorCallDoctorView';
import { PresenceChip, DisconnectBand } from './DoctorCallParts';

const pad = (n) => String(n).padStart(2, '0');

// exitPath = [나가기] 목적지 — 접수(deskReception)가 켜져 있으면 /reception, 아니면 /dashboard(치과는 App.js 가 치과 착지로 보낸다)
function DoctorCallScreen({ user, exitPath = '/dashboard' }) {
    const navigate = useNavigate();
    const location = useLocation();
    const clinicId = user?.companyId || user?.uid;
    const dc = useDoctorCall(clinicId, true);
    const isDoctor = new URLSearchParams(location.search).get('view') === 'doctor';

    // 시계 = 서버 시각 기준(KST 표시)
    const d = new Date(dc.nowMs);
    const kst = new Date(d.getTime() + 9 * 3600000);
    const clock = `${pad(kst.getUTCHours())}:${pad(kst.getUTCMinutes())}`;

    return (
        <div style={F.page}>
            <div style={F.top}>
                <PresenceChip present={dc.present} big />
                {isDoctor && <span style={F.mode}>{'원장 보기'}</span>}
                <span style={F.clock}>{clock}</span>
            </div>
            {!dc.connected && <div style={{ marginBottom: 12 }}><DisconnectBand loaded={dc.loaded} /></div>}
            {dc.err && <div style={F.err}>{dc.err}</div>}
            <div style={{ maxWidth: isDoctor ? 760 : 1200, margin: '0 auto' }}>
                {isDoctor
                    ? <DoctorCallDoctorView settings={dc.settings} calls={dc.calls} present={dc.present} nowMs={dc.nowMs} loaded={dc.loaded} disabled={!dc.connected} onAck={dc.ack} onPresent={dc.setPresent} />
                    : <DoctorCallGrid settings={dc.settings} calls={dc.calls} nowMs={dc.nowMs} disabled={!dc.connected} onCell={dc.toggleCell} />}
            </div>
            <div style={F.corner}>
                <button type="button" onClick={() => navigate(isDoctor ? '/call' : '/call?view=doctor', { replace: true })} style={F.small}>{isDoctor ? '격자 보기' : '원장 보기'}</button>
                <button type="button" onClick={() => navigate(exitPath)} style={F.small}>{'나가기'}</button>
            </div>
        </div>
    );
}

const F = {
    page: { minHeight: '100vh', background: '#ffffff', color: '#17201d', padding: '16px 18px 64px', boxSizing: 'border-box', colorScheme: 'light' },
    top: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14, flexWrap: 'wrap' },
    mode: { fontSize: 14, fontWeight: 700, color: '#46524e', background: '#f5f7f6', border: '1px solid #d9dfdc', borderRadius: 999, padding: '3px 12px' },
    clock: { marginLeft: 'auto', fontFamily: 'ui-monospace, Menlo, monospace', fontSize: 30, fontWeight: 700, fontVariantNumeric: 'tabular-nums' },
    err: { fontSize: 13.5, color: '#8a2020', background: '#fdecec', border: '1px solid #f5cfcf', borderRadius: 8, padding: '8px 12px', marginBottom: 12 },
    corner: { position: 'fixed', right: 10, bottom: 10, display: 'flex', gap: 6, opacity: 0.75 },
    small: { border: '1px solid #d9dfdc', background: '#fff', color: '#46524e', borderRadius: 7, padding: '4px 10px', fontSize: 12, cursor: 'pointer' },
};

export default DoctorCallScreen;
